module.exports = __webpack_public_path__ + "static/media/Samsung Galaxy Note10+ Aura Blue.3ada0fe1.png";